import { apiClient } from './client'
import { API_URL } from '@/lib/utils/constants'
import type {
  ValidateCodeResponse,
  RedeemCodeRequest,
  RedeemCodeResponse,
  UserEntitlement,
} from '@/types'

export const entitlementsApi = {
  // Validate an employer code (public endpoint - no auth required)
  validateCode: async (code: string): Promise<ValidateCodeResponse> => {
    const url = `${API_URL}/entitlements/validate`
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })

    if (!response.ok) {
      // For invalid codes, the API returns 400 with a message
      if (response.status === 400 || response.status === 404) {
        return { valid: false, message: 'Invalid or expired employer code' }
      }
      throw new Error('Failed to validate code')
    }

    return response.json()
  },

  // Redeem an employer code for a family
  redeemCode: (data: RedeemCodeRequest) =>
    apiClient.post<RedeemCodeResponse>('/entitlements/redeem', data),

  // Get current user's entitlements
  getUserEntitlements: () =>
    apiClient.get<UserEntitlement[]>('/users/entitlements'),
}
